import { useT } from "../i18n";
import { Fotos } from "./Fotos";
import type { Bild } from "../daten/fotos";
import type { Fotoverteilung } from "../daten/fotoverteilung";
import "../stile/vorbereitung.css";

export { fotosVerteilen } from "../daten/fotoverteilung";

/* ══════════════════════════════════════════════════════════════════
   Die Fotos eines Protokolls — geordnet nach dem, wofür sie gemacht
   wurden (L1, 25.09.2026).

   Luca: Im Vorgang sind die Fotos der Vorbereitung da, aber nicht zu
   erkennen, zu welchem Prüfpunkt oder Pflichtfoto sie gehören. Bis hierher
   standen sie überall als eine flache Reihe — in der Vorbereitung, in der
   Übergabe, in der Rücknahme —, obwohl jedes Bild es wusste.

   **Eine Verteilung, drei Leser** (`daten/fotoverteilung.ts`). Der
   Vorbereitungsblick hängt die Frage-Fotos unter ihre Antwort, das Protokoll
   am Auftrag zeigt die Pflichtplätze in der Reihenfolge der Liste, und was
   übrig ist, steht unter „Weitere". Wer die Regel ein zweites Mal baut, hat
   zwei, die auseinanderlaufen.
   ══════════════════════════════════════════════════════════════════ */

const pfadeVon = (bilder: Bild[]): string[] => bilder.map((b) => b.pfad).filter(Boolean);

/** Die Fotos einer Prüffrage — unter ihrer Antwort, oder nichts. */
export function Fragefotos({ bilder }: { bilder: Bild[] | undefined }) {
  if (!bilder?.length) return null;
  return <div className="fotogruppe-frage"><Fotos pfade={pfadeVon(bilder)} /></div>;
}

/**
 * Pflichtplätze und „Weitere" — die Frage-Fotos stehen beim Leser unter ihrer
 * Antwort und hier nicht noch einmal.
 */
export function Fotogruppen({ verteilung, leer }: {
  verteilung: Fotoverteilung<Bild>;
  /** Was dasteht, wenn es gar kein Bild und keinen Pflichtplatz gibt — ein i18n-Schlüssel. */
  leer?: string;
}) {
  const t = useT();
  const { jePlatz, weitere, jeFrage } = verteilung;
  if (!jePlatz.length && !weitere.length) {
    return leer && !jeFrage.size ? <span className="foto-keine">{t(leer)}</span> : null;
  }
  return (
    <div className="fotogruppen">
      {jePlatz.length ? (
        <div className="fotogruppe">
          <span className="feld-schild">{t("pflichtfoto.titel")}</span>
          <dl className="fotogruppe-plaetze">
            {jePlatz.map(({ platz, bilder }) => (
              <div key={platz}>
                <dt>{t("pflichtfoto.fotoVon", { platz: t(`pflichtfoto.blickwinkel.${platz}`) })}</dt>
                <dd>
                  {bilder.length
                    ? <Fotos pfade={pfadeVon(bilder)} />
                    : <span className="foto-keine">{t("pflichtfoto.nichtVorhanden")}</span>}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      ) : null}
      {weitere.length ? (
        <div className="fotogruppe">
          <span className="feld-schild">
            {t(jePlatz.length || jeFrage.size ? "pflichtfoto.weitere" : "vorgang.protFotosWort")}
          </span>
          <Fotos pfade={pfadeVon(weitere)} />
        </div>
      ) : null}
    </div>
  );
}
